import {Translator} from '@logistics-frontend/core/i18n'
import {
  AddressError,
  AsyncStatus,
  DraftAddress,
  DraftPayment,
  DraftState,
  get,
  State,
} from '@yandex-taxi/react-integration-api'

import {Tariff} from './components/consts'

const UNSUPPORTED_PAYMENT_METHOD = 'specified payment method can’t be used to pay for this ride'

const checkPhone = (t: Translator, phone?: string): string | void => {
  if (!phone) {
    return t('order.form.enter_phone_number', 'Введите номер телефона')
  }
}

const getValidators = (t: Translator) =>
  Object.entries({
    tariff: (tariff?: string): string | undefined => {
      if (!tariff) {
        return t('order.form.tariff.choose_plan', 'Выберите тариф')
      }
    },
    payment: (payment: DraftPayment | undefined, draftState: DraftState, state: State): string | undefined => {
      if (!payment?.id) {
        return t('order.payment.choose_payment_method', 'Выберите способ оплаты')
      }

      const {estimate} = state.async
      const errorText = get(estimate, ['error', 'data', 'error', 'text'])

      if (estimate.status === AsyncStatus.ERROR && errorText === UNSUPPORTED_PAYMENT_METHOD) {
        return t('order.payment.selected_payment_method_not_supported', 'Выбранный способ оплаты не поддерживается')
      }
    },
    route: (route: DraftAddress[], values?): (AddressError | undefined)[] | undefined => {
      let errorCount = 0

      // eslint-disable-next-line array-callback-return
      const errors = route.map((routePoint, index) => {
        let mayBeError
        const address = routePoint.address?.geoObject
        const phoneError =
          index === 0 || values.tariff !== Tariff.CARGO ? checkPhone(t, routePoint?.contactPhone) : null

        if (!address) {
          mayBeError = {address: t('order.route.enter_address', 'Введите адрес')}
        }

        if (phoneError) {
          mayBeError = Object.assign({}, mayBeError, {contactPhone: phoneError})
        }

        if (mayBeError) {
          errorCount += 1

          return mayBeError
        }
      })

      if (errorCount) {
        return errors
      }
    },
  })

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fullValidate: any = (t: Translator) => (values: DraftState, state: State) => {
  return getValidators(t).reduce((errors, [key, validator]) => {
    const value = values[key]
    const error = validator(value, values, state)

    if (error) {
      return Object.assign({}, errors, {
        [key]: error,
      })
    }

    return errors
  }, undefined)
}
